/* eslint-disable import/no-cycle */
import React from 'react';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'react-i18next';
import {Space} from 'antd';
import FormModal from '../shared/modal/FormModal';
import BatchLogForm from './BatchLogForm';
import LastCreatedBatch from '../producedMaterial/LastCreatedBatch';
import ConsumedComponents from '../producedMaterial/ConsumedComponents';
import BatchProperties from '../producedMaterial/BatchProperties';

const ViewBatchLog = ({yie, consumptionLog, onCancel, onExport}) => {
  const {t} = useTranslation();

  return (
    <FormModal title={t('batchLog.view.title')} visible onCancel={onCancel}>
      <Space direction={'vertical'} style={{width: '100%'}}>
        <LastCreatedBatch batch={yie.batch}/>
        {consumptionLog.length ? <ConsumedComponents consumptionLog={consumptionLog}/> : ''}
        {Object.keys(yie.batch?.properties).length ? <BatchProperties properties={yie.batch.properties}/> : ''}
        <BatchLogForm onCancel={onCancel} onExport={onExport}/>
      </Space>
    </FormModal>
  );
};

export default observer(ViewBatchLog);
